import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CloseIcon from '@material-ui/icons/Close';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import WarningIcon from '@material-ui/icons/Warning';
import React, { FC, useState } from 'react';
import {
  Typography,
  Box,
  SvgIconProps,
  SnackbarContent,
  makeStyles,
  Snackbar,
  IconButton
} from '@material-ui/core';

type SnackbarVariant = 'success' | 'error' | 'info' | 'warn';

const useStyles = makeStyles(theme => ({
  success: {
    backgroundColor: theme.palette.primary.dark
  },
  error: {
    backgroundColor: theme.palette.error.dark
  },
  info: {
    backgroundColor: theme.palette.primary.main
  },
  warn: {
    backgroundColor: theme.palette.secondary.dark
  },
  iconVariant: {
    fontSize: 20,
    opacity: 0.9,
    marginRight: theme.spacing(1)
  },
  message: {
    display: 'flex',
    alignItems: 'center'
  }
}));

const MySnackbarIcon: FC<SvgIconProps & { variant: SnackbarVariant }> = ({
  variant,
  ...svgIconProps
}) => {
  switch (variant) {
    case 'success':
      return <CheckCircleIcon {...svgIconProps} />;
    case 'warn':
      return <WarningIcon {...svgIconProps} />;
    case 'error':
      return <ErrorIcon {...svgIconProps} />;
    case 'info':
      return <InfoIcon {...svgIconProps} />;
  }
};

export interface ShowSnackbarsProps {
  message: string;
  variant: 'success' | 'error' | 'info' | 'warn';
  vertical: 'top' | 'bottom';
  horizontal: 'left' | 'center' | 'right';
}

const ShowSnackbars: FC<ShowSnackbarsProps> = ({
  message,
  variant,
  vertical,
  horizontal
}) => {
  const classes = useStyles() as { [name: string]: string };
  const [open, setOpen] = useState(true);

  const handleClose = (reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  return (
    <Snackbar
      anchorOrigin={{ vertical, horizontal }}
      open={open}
      onClose={(_e, reason: string) => handleClose(reason)}
    >
      <SnackbarContent
        className={classes[variant]}
        aria-describedby="client-snackbar"
        message={
          <Box className={classes.message}>
            <MySnackbarIcon variant={variant} className={classes.iconVariant} />
            <Typography variant="body2">{message}</Typography>
          </Box>
        }
        action={[
          <IconButton
            key="close"
            aria-label="close"
            color="inherit"
            onClick={() => handleClose()}
          >
            <CloseIcon className={classes.icon} />
          </IconButton>
        ]}
      />
    </Snackbar>
  );
};

export default ShowSnackbars;
